import React, { useEffect } from "react";
import { usePlanConfigStore } from "./plan-config";

const StoreInitializer: React.FC = () => {
  const { fetchConfigurations, initialized, isLoading } = usePlanConfigStore();

  useEffect(() => {
    if (!initialized && !isLoading) {
      fetchConfigurations();
    }
  }, [fetchConfigurations, initialized, isLoading]);

  return null;
};

export default StoreInitializer;
